import { render, staticRenderFns } from "./AppVersionInfo.vue?vue&type=template&id=440a5fcc"
import script from "./AppVersionInfo.vue?vue&type=script&lang=js"
export * from "./AppVersionInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports